import React from 'react';
import { Reveal } from './Reveal';
import { CTABanner } from './CTABanner';
import { useParallax } from '../hooks/useParallax';
import { useLanguage } from '../contexts/LanguageContext';
const FINANCE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/235f7c1d-e7ea-474b-8a85-5741ec326282.jpg';
export function FinanceTradeIn() {
  const {
    t
  } = useLanguage();
  const {
    ref,
    offset
  } = useParallax<HTMLDivElement>(0.3);
  return <section id="financiamiento" aria-labelledby="financiamiento-title" className="scroll-mt-24 border-t border-line bg-canvas" data-id="element-39" data-mp="3hsttfibgl4cp">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-40" data-mp="37ue5tpbn4d7y">
        <div ref={ref} className="relative h-80 overflow-hidden bg-surface sm:h-[28rem] lg:h-full lg:min-h-[680px]" data-id="element-41" data-mp="37vywv4yqxe12">
          <img src={FINANCE_IMAGE} alt={t.finance.imageAlt} loading="lazy" className="absolute inset-0 h-[150%] w-full object-cover opacity-85" style={{
          transform: `translate3d(0, ${offset}px, 0)`
        }} data-id="element-42" data-mp="1wefypr00w19d" />
        </div>

        <div className="flex flex-col justify-center bg-canvas px-5 py-16 sm:px-6 sm:py-24 lg:border-l lg:border-line lg:px-20 lg:py-32" data-id="element-43" data-mp="1lqbv6zkm8351">
          <Reveal data-id="element-44" data-mp="1zr65jnr84e6c">
            <p className="text-[11px] uppercase tracking-[0.34em] text-mute" data-id="element-45" data-mp="1znia2j27xhoz">{t.finance.eyebrow}</p>
            <h2 id="financiamiento-title" className="mt-6 max-w-lg text-[32px] font-light leading-[1.08] tracking-[-0.03em] text-white lg:text-[52px]" data-id="element-46" data-mp="1usl45l08jogb">
              {t.finance.title}
            </h2>
            <p className="mt-8 max-w-lg text-base font-light leading-[1.8] text-mute lg:text-lg" data-id="element-47" data-mp="2igm6udaqgant">
              {t.finance.body}
            </p>
          </Reveal>

          <Reveal delay={0.08} data-id="element-48" data-mp="2djc98ad6wsow">
            <ul className="mt-12 divide-y divide-line border-y border-line" data-id="element-49" data-mp="2sdqxoqfiwuay">
              {t.finance.steps.map(step => <li key={step.label} className="flex items-baseline justify-between gap-6 py-5" data-id="element-50" data-mp="2nggxcfqliy8c">
                  <span className="text-[15px] text-white" data-id="element-51" data-mp="2ujouf4mbsodb">{step.label}</span>
                  <span className="text-right text-[12px] font-light text-mute" data-id="element-52" data-mp="2zgp21jytpz6j">
                    {step.detail}
                  </span>
                </li>)}
            </ul>
          </Reveal>

          <Reveal delay={0.16} data-id="element-53" data-mp="398bka09kwyis">
            <div className="mt-10 flex flex-col gap-3 sm:mt-12 sm:flex-row sm:flex-wrap" data-id="element-54" data-mp="398l1ozgk5xcv">
              <a href="#contacto" className="btn-glint btn-glint-sheen btn-halo-red inline-flex items-center justify-center bg-guards px-10 py-4 text-[13px] font-medium tracking-wide text-white hover:bg-guards-bright" data-id="element-55" data-mp="3e5to5c8qonjx">
                <span data-id="element-56" data-mp="3s6e5e3z0abbb">{t.finance.ctaPrimary}</span>
              </a>
              <a href="#contacto" className="btn-glint btn-glint-sheen btn-halo-blue inline-flex items-center justify-center border border-gentian-bright/70 px-10 py-4 text-[13px] font-medium tracking-wide text-white transition-colors duration-500 ease-[var(--ease-lux)] hover:border-gentian-bright hover:bg-gentian/25" data-id="element-57" data-mp="1st0aq8ulx6wi">
                <span data-id="element-58" data-mp="1lgkkcv436yif">{t.finance.ctaSecondary}</span>
              </a>
            </div>
          </Reveal>
        </div>
      </div>

      {/* Banner interactivo — calculadora de leasing */}
      <div className="mx-auto max-w-[1520px] px-5 pb-16 pt-14 sm:px-6 sm:pb-24 sm:pt-20 lg:px-14 lg:pb-32 lg:pt-28" data-id="element-59" data-mp="1bl958bornpa5">
        <CTABanner eyebrow={t.finance.banner.eyebrow} title={t.finance.banner.title} description={t.finance.banner.description} ctaLabel={t.finance.banner.cta} ctaHref="#contacto" tone="red" data-id="element-60" data-mp="295dhuw0cxef5" />
      </div>
    </section>;
}